import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { PaymentCard } from 'models/paymentCard';
import { getFlagByAlpha2 } from 'services/countriesService';
import { cardTypeNormalize } from 'utils/payment';

import { Flag } from './styles';

export interface Props {
  card: PaymentCard;
  countryCode: string;
}

const PaymentCardFlag = ({ card, countryCode }) => {
  const [flagImage, setFlagImage] = useState('');
  let { cardType } = card;
  cardType = cardTypeNormalize(cardType);
  const card_image = useMemo(
    () =>
      cardType.match(/master|amex|visa/gi) === null
        ? '/corporate/images/payment/cc/payment.svg'
        : `/corporate/images/payment/cc/${cardType.toLowerCase()}.svg`,
    [cardType],
  );

  const getCardImage = useCallback(async () => {
    if (countryCode.toLowerCase().match(/ar|br|cl|co|cr|ec|pr|mx|ur/gi) !== null) {
      setFlagImage(`/corporate/images/payment/country/${countryCode.toLowerCase()}.svg`);
    }
    try {
      const { flag } = await getFlagByAlpha2(countryCode);
      const els = document.querySelectorAll(`[data-flag-id="${countryCode}"]`);
      for (const el in els) {
        els[el].setAttribute('style', `background-image: url(${flag})`);
      }
    } catch (e) {}
  }, [countryCode]);

  useEffect(() => {
    getCardImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flag data-test-id={countryCode}>
      <Flag.Icon src={card_image} alt={cardType} />
      {/*flagImage !== '' ? (
        <Flag.Image src={flagImage} data-flag-id={countryCode}></Flag.Image>
      ) : (
        <Flag.Image data-flag-id={countryCode}></Flag.Image>
      )*/}
    </Flag>
  );
};

export default PaymentCardFlag;
